import React from 'react';
import { View, TextInput, ActivityIndicator, StyleSheet, Pressable, Image } from 'react-native';

import { COLOR, THEME, __WEB__, FONT } from '../../constants/styles';

import OPComponent from './op_component';

function ContainerComp(props) {
  if (__WEB__) {
    return (
      <div className="no-outline" style={{ flex: 1, flexDirection: 'row' }}>
        {props.children}
      </div>
    );
  }
  return props.children;
}

export default class Search extends OPComponent {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
      focused: false,
    };

    this._inputRef = React.createRef();
  }

  handleClearPress = () => {
    this._inputRef?.current?.clear();
    this.props.handleChangeText('');
  };

  clearInput = () => {
    this._inputRef?.current?.clear();
    this.props.handleChangeText('');
  };

  focusInput = () => {
    this._inputRef?.current?.focus();
  };

  renderCloseBtn() {
    if (!__WEB__) return null;

    return (
      <Pressable onPress={this.handleClearPress} style={styles.closeButton}>
        <Image
          style={[
            styles.closeIcon,
            this.state.hovered || this.state.focused ? styles.closeIconHovered : null,
          ]}
          source={require('../../../resources/icon-close.png')}
        />
      </Pressable>
    );
  }

  onHoverIn = () => {
    this.setState({ hovered: true });
  };
  onHoverOut = () => {
    this.setState({ hovered: false });
  };
  onInputFocus = () => {
    this.props.onInputFocus?.();
    this.setState({ focused: true });
  };
  onInputBlur = () => {
    this.props.onInputBlur?.();
    this.setState({ focused: false });
  };

  render() {
    const props = this.props;
    const {
      children,
      handleChangeText,
      placeholder,
      value,
      textStyle,
      loading,
      containerStyle,
      onSubmit,
    } = props;

    return (
      <Pressable
        style={[
          styles.searchContainer,
          containerStyle,
          this.state.focused
            ? styles.searchContainerFocused
            : this.state.hovered
              ? styles.searchContainerHovered
              : null,
        ]}
        onHoverIn={__WEB__ ? this.onHoverIn : null}
        onHoverOut={__WEB__ ? this.onHoverOut : null}
      >
        <View style={styles.inputContainer}>
          <Image
            style={[
              styles.searchIcon,
              this.state.hovered || this.state.focused ? styles.searchIconHovered : null,
            ]}
            source={require('../../../resources/icon-search.png')}
          />
          <ContainerComp>
            <TextInput
              ref={this._inputRef}
              style={[styles.input, textStyle, { width: '100%' }]}
              autoFocus={false}
              defaultValue={value}
              placeholder={placeholder}
              placeholderTextColor={
                this.state.hovered || this.state.focused ? COLOR.text : COLOR.textLight
              }
              autoCapitalize="words"
              keyboardType="default"
              autoComplete="off"
              autoCorrect={false}
              returnKeyType={onSubmit ? 'go' : 'done'}
              selectTextOnFocus={true}
              clearButtonMode="while-editing"
              onChangeText={handleChangeText}
              underlineColorAndroid="transparent"
              onFocus={this.onInputFocus}
              onBlur={this.onInputBlur}
              onSubmitEditing={onSubmit}
            />
          </ContainerComp>
          {this.renderCloseBtn()}
        </View>
        {!!loading && <ActivityIndicator animating={true} size="large" color="gray" />}
        {children}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  searchContainer: __WEB__
    ? {
        backgroundColor: COLOR.contrast,
        borderRadius: 5,
        borderWidth: 2,
        borderColor: 'rgb(234, 234, 234)',
      }
    : {
        backgroundColor: COLOR.contrast,
      },
  searchContainerHovered: {
    borderColor: 'rgb(200, 200, 200)',
  },
  searchContainerFocused: {
    borderColor: '#0099cc',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 15,
    marginRight: __WEB__ ? 10 : 15,
    paddingBottom: 3,
  },
  input: {
    ...THEME.input,
    ...FONT.light,
    fontSize: __WEB__ ? 14 : 14,
    height: __WEB__ ? 35 : 40,
  },
  searchIcon: {
    width: 20,
    height: 20,
    tintColor: '#CCC',
    marginRight: 10,
    marginTop: 5,
  },
  searchIconHovered: {
    tintColor: 'rgb(98, 98, 98)',
  },
  closeButton: {
    alignSelf: 'stretch',
    justifyContent: 'center',
    paddingLeft: 15,
    paddingRight: 5,
    paddingTop: 5,
  },
  closeIcon: {
    width: 12,
    height: 14,
    tintColor: '#CCC',
  },
  closeIconHovered: {
    tintColor: 'rgb(98, 98, 98)',
  },
});
